<template>
  <div>
    <el-row>

      <el-form size="medium" :inline="true" class="demo-form-inline">
        <el-form-item label="状态">
          <el-select v-model="STATUS" @change="handleChange" placeholder="请选择">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="showAddPosition()">新增库位</el-button>
          <el-button @click="showImportPosition()">导入库位</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableDataPage" border stripe @filter-change="filterWarehouse">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="CODE" label="库位编码"></el-table-column>
          <el-table-column prop="TYPE_NAME" label="仓库区域" :filters="warehouseTypeFilter" column-key="TYPE_NAME">
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.STATUS === 1" type="success">启用</el-tag>
              <el-tag type="danger" v-else>禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="50">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="edit(scope.row)">修改</el-button>
              <el-button v-if="scope.row.STATUS" type="text" style="color:red" size="small"
                @click="disablePosition(scope.row)">
                禁用
              </el-button>
              <el-button v-if="!scope.row.STATUS" type="text" style="color:blue" size="small"
                @click="enablePosition(scope.row)">
                启用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleDialogChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="dialog_count">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="新增库位" center :visible.sync="addPositionVisible" width="450px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" size="small" :inline="true">
        <el-form-item label="仓库区域：" prop="lineInput">
          <el-select v-model="addForm.warehouseTypeID" placeholder="请选择" style="width: 276px">
            <el-option v-for="item in warehouseTypeList" :key="item.ID" :label="item.TYPE_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库位编码：" prop="lineInput">
          <el-input ref="positionCode1" v-model="addForm.positionCode1" style="width: 60px" maxlength="2"
            @input="input1($event, 1)" placeholder="库房">
          </el-input> -
          <el-input ref="positionCode2" v-model="addForm.positionCode2" style="width: 60px" maxlength="2"
            @input="input($event, 2)" placeholder="库区">
          </el-input> -
          <el-input ref="positionCode3" v-model="addForm.positionCode3" style="width: 60px" maxlength="2"
            @input="input($event, 3)" placeholder="库位">
          </el-input> -
          <el-input ref="positionCode4" v-model="addForm.positionCode4" style="width: 60px" maxlength="2"
            @input="input($event, 4)" placeholder="层高">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addPositionVisible = false">取 消</el-button>
        <el-button size="small" @click="addPosition()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改仓库区域" center :visible.sync="editDialog" width="450px" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" size="small" :inline="true">
        <el-form-item label="仓库区域：" prop="WS_TYPE_ID">
          <el-select v-model="editForm.WS_TYPE_ID" placeholder="请选择" style="width: 276px">
            <el-option v-for="item in warehouseTypeList" :key="item.ID" :label="item.TYPE_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editDialog = false">取 消</el-button>
        <el-button size="small" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入库位信息" center :visible.sync="importPositionVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="importPositionForm" :model="importPositionForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.importPositionForm.file" multiple :file-list="fileList" :limit="1">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downImportPositionTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeImportPosition()">取 消</el-button>
        <el-button size="small" @click="submitImportPosition()" :loading="loading2">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryPosition, addWarehousePosition, queryWarehouseType, updatePositionStatus, importPosition,
  updatePosition,
} from '@/assets/api/warehouseManager';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '10056',
      STATUS: null,
      searchForm: {},
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      addPositionVisible: false,
      statusList: [
        { value: null, label: '全部' },
        { value: '1', label: '启用' },
        { value: '0', label: '禁用' },
      ],
      addForm: {
        positionCode1: '',
        positionCode2: '',
        positionCode3: '',
        positionCode4: '',
      },
      warehouseTypeList: [],
      importPositionVisible: false,
      importPositionForm: {
        file: 'tmp',
      },
      url: '',
      fileList: [],
      loading2: false,
      tableDataPage: [],
      tableDataTemp: [],
      dialog_count: 0,
      warehouseTypeFilter: [],
      disableDialogVisible: false,
      disableForm: {},
      editForm: {},
      editDialog: false,
    };
  },
  created() {
    this.queryBeforeFun();
    this.queryWarehouseFilter();
    this.queryData(1);
    this.getWarehouseTypeList();
  },
  computed: {
    // 库位信息
    POSITION_CONDITION() {
      return this.$store.state.POSITION_CONDITION;
    },
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryData(index = this.currentPage) {
      const params = {};
      if (this.STATUS) {
        params.STATUS = Number(this.STATUS);
      }
      queryPosition(params).then((result) => {
        this.tableData = result.map((item) => Object.assign(item, { CODE: item.CODE.toString() }));
        this.dialog_count = result.length;
        this.tableDataTemp = this.tableData;
        this.$store.dispatch('SET_POSITION_CONDITION', {
          POSITIONLIST: result,
        });
        this.loadPageChangeProducts(index - 1);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleChange() {
      this.currentPage = 1;
      this.queryData(1);
    },
    showAddPosition() {
      this.addPositionVisible = true;
      this.addForm = {};
    },
    getWarehouseTypeList() {
      queryWarehouseType().then((res) => {
        if (res.length === 0) {
          this.warehouseTypeList = [];
        }
        this.warehouseTypeList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryWarehouseFilter() {
      queryWarehouseType()
        .then((res) => {
          if (res.length === 0) {
            this.warehouseTypeFilter = [];
          }
          this.warehouseTypeFilter = res;
          this.warehouseTypeFilter = this.warehouseTypeFilter.map((item) => ({ text: item.TYPE_NAME, value: item.TYPE_NAME }));
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    addPosition() {
      const data = {
        CODE: `${this.addForm.positionCode1}-${this.addForm.positionCode2}-${this.addForm.positionCode3}-${this.addForm.positionCode4}`,
        WS_TYPE_ID: this.addForm.warehouseTypeID,
      };
      addWarehousePosition(data)
        .then((res) => {
          this.$message.show({ text: '成功', type: 'success' });
          this.addPositionVisible = false;
          this.queryData();
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
          this.addPositionVisible = false;
        });
    },
    disablePosition({ ID: LOCATION_ID }) {
      this.$confirm('确定禁用该库位吗？', '提示', { type: 'warning' }).then(() => {
        const data = {
          LOCATION_ID,
          STATUS: 0,
        };
        updatePositionStatus(data).then((res) => {
          this.queryData();
          this.$message.show({ text: '已禁用', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      });
    },
    enablePosition({ ID: LOCATION_ID }) {
      const data = {
        LOCATION_ID,
        STATUS: 1,
      };
      updatePositionStatus(data).then((res) => {
        this.queryData();
        this.$message.show({ text: '已启用', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    showImportPosition() {
      this.importPositionVisible = true;
    },
    closeImportPosition() {
      this.importPositionVisible = false;
      this.fileList = [];
    },
    submitImportPosition() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            FILE_NAME: this.url,
          };
          this.loading2 = true;
          importPosition(params).then((result) => {
            if (result[0]) {
              this.$message.show({ text: '部分导入失败，详情请查看文件', type: 'warning' });
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            } else {
              this.$message.show({ text: '导入成功', type: 'success' });
              this.queryData();
            }
            this.fileList = [];
            this.importPositionVisible = false;
            this.loading2 = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.importPositionVisible = false;
            this.loading2 = false;
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    downImportPositionTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/ImportLocation.xlsx';
    },
    handleDialogChange() {
      this.loadPageChangeProducts();
    },
    loadPageChangeProducts(pageIndex = this.currentPage - 1, pageSize = this.pageSize - 1) {
      const INDEX = pageIndex * (pageSize + 1);
      const END = INDEX + pageSize + 1;
      if (END > this.tableDataTemp.length) {
        this.tableDataPage = this.tableDataTemp.slice(INDEX);
      } else {
        this.tableDataPage = this.tableDataTemp.slice(INDEX, END);
      }
    },
    filterWarehouse(value, row) {
      if (value.TYPE_NAME.length === 0) {
        this.tableDataTemp = this.tableData;
        this.tableDataTemp.push(1);
        this.tableDataTemp.pop();
        this.dialog_count = this.tableData.length;
        this.loadPageChangeProducts();
        return;
      }
      this.tableDataTemp = this.tableData.filter((item) => value.TYPE_NAME.includes(item.TYPE_NAME));
      this.loadPageChangeProducts();
      this.dialog_count = this.tableDataTemp.length;
    },
    input(value, index) {
      this.addForm[`positionCode${index}`] = value.replace(/[^\d]/g, '');
      if (this.addForm[`positionCode${index}`].length == 2 && index != 4) {
        this.$refs[`positionCode${index + 1}`].focus();
      }
    },
    input1(value, index) {
      this.addForm[`positionCode${index}`] = value.replace(/[^\w\/]/ig, '');
      if (this.addForm[`positionCode${index}`].length == 2 && index != 4) {
        this.$refs[`positionCode${index + 1}`].focus();
      }
    },
    edit({ ID: LOCATION_ID, WS_TYPE_ID }) {
      this.editForm = { LOCATION_ID, WS_TYPE_ID };
      this.editDialog = true;
    },
    submitEdit() {
      updatePosition(this.editForm).then((res) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editDialog = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped lang="css">

  div /deep/ .editNum input::-webkit-outer-spin-button,
  div /deep/ .editNum input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  div /deep/ .editNum input[type='number'] {
    -moz-appearance: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/warehousePosition.vue